import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from "@mui/material/Tooltip";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const InfoModal = ({ showInfo, setShowInfo, expectedColumns }) => {
  const handleClose = () => {
    setShowInfo(false);
  };

  const handleDownload = data => {
    const fileDownload = require('js-file-download');
    const columns = data.expected_columns.join(',');
    const blob = new Blob([columns], { type: 'text/csv' });
    fileDownload(blob, `${data.file_type_name}.csv`);
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showInfo}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Expected Columns
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {
            expectedColumns.map((data, index) => (
              <Box key={`box-${index}`}>
                <Box sx={{
                  display: 'flex'
                }}>
                  <Typography key={`head-${index}`}><strong>{data.file_type_name}</strong></Typography>
                  <Tooltip title="Download loader sheet template" arrow>
                    <IconButton size='small' sx={{ marginTop: -0.4 }} onClick={() => handleDownload(data)}>
                      <DownloadIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                </Box>
              
                <Typography key={`list-${index}`} gutterBottom>
                  {data.expected_columns.join(', ')}
                </Typography>
              </Box>
            ))
          }
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};

InfoModal.propTypes = {
  showInfo: PropTypes.bool.isRequired,
  setShowInfo: PropTypes.func.isRequired,
};

export default InfoModal;